// @flow

/**
 * Returns true if given object is a message object. False otherwise
 * @param  {any} val
 * @return {bool}
 */
const isMessageObject = (val: any) => !!(val && val.id && val.domain)

export default isMessageObject
